import { useMutation, useQuery } from 'react-query';
import { PunchInOutService } from '@api/PunchInOutService';
import { SettingService } from '@api/SettingService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListPunchInOut = (
  [
    page_no,
    searchText,
    selectedStatus,
    selectedEmployee,
    selectedMachineName,
    selectedPunchType,
    FromDate,
    ToDate,
    selectedFilterTab
  ],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    [
      'biometric-list',
      page_no,
      searchText,
      selectedStatus,
      selectedEmployee,
      selectedMachineName,
      selectedPunchType,
      FromDate,
      ToDate,
      selectedFilterTab
    ],
    PunchInOutService.listPunchInOut,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

// Get Approver
const useGetBioMetricApproverList = (params, onSuccess, onError = onDefaultError) => {
  return useQuery(['biometric-approver-list', params], PunchInOutService.approverList, {
    onSuccess,
    onError
  });
};

// Details
const useViewBioMetric = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('biometric-view', () => PunchInOutService.viewBioMetric(id), {
    onSuccess,
    onError
  });
};

// Update
const useUpdateBioMetric = (onSuccess, onError = onDefaultError) => {
  return useMutation(PunchInOutService.updateBioMetric, {
    onSuccess,
    onError
  });
};

const usePunchInOutUpdateUser = (onSuccess, onError = onDefaultError) => {
    return useMutation(PunchInOutService.punchInOutUpdateUser, {
      onSuccess,
      onError
    });
  };


const useUpdateBioMetricStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(PunchInOutService.changeStatusBioMetric, {
    onSuccess,
    onError
  });
};

// Get Approver
const useGetBioMetricEmployeeList = (params, onSuccess, onError = onDefaultError) => {
  return useQuery(['biometric-employee-list', params], PunchInOutService.EmployeeList, {
    onSuccess,
    onError
  });
};

const useDeleteBioMetric = (onSuccess, onError = onDefaultError) => {
return useMutation(PunchInOutService.deleteBioMetric, {
    onSuccess,
    onError
});
};

const useOwnListPunchInOut = (
    [
      page_no,
      selectedStatus,
      selectedFilterTab,
      FromDate,
      ToDate,
    ],
    onSuccess,
    onError = onDefaultError
  ) => {
    return useQuery(
      [
        'own-biometric-records',
        page_no,
        selectedStatus,
        selectedFilterTab,
        FromDate,
        ToDate,
      ],
      PunchInOutService.ownPunchInOutList,
      {
        onSuccess,
        keepPreviousData: true,
        onError
      }
    );
  };
const useShowBioMetric = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('biometric-show', () => PunchInOutService.showBioMetric(id), {
    onSuccess,
    onError
  });
};

const useBioMetricSetting = (onSuccess, onError = onDefaultError) => {
    return useQuery('biometric_setting_data', () => SettingService.getSettingData(), {
      onSuccess,
      onError
    });
  };


export {
  useListPunchInOut,
  useGetBioMetricApproverList,
  useViewBioMetric,
  useUpdateBioMetric,
  useUpdateBioMetricStatus,
  useGetBioMetricEmployeeList,
  useDeleteBioMetric,
  usePunchInOutUpdateUser,
  useOwnListPunchInOut,
  useShowBioMetric,
  useBioMetricSetting,
};
